import PlusPlan from "./ic-plus.svg"
import PlanArchive from "./ic-archive.svg"
import PlanNotification from "./ic-notification.svg"
import PlanLock from "./ic-lock.svg"
import PlanUsersShare from "./ic-users-arrow.svg"

function ComponentPlus() {
    return (
        <div className='w-80 flex-shrink-0 flex flex-col space-y-3 justify-center items-center lg:w-96'>
            <img className="h-10" src={PlusPlan} alt="Professional Plan" />
            <h5 className="text-xl font-medium">Powerful. Organized. Efficient.</h5>
            {/* <h5 className="text-xl font-medium">25000DA</h5> */}
            <div className='w-full h-px rounded-full bg-secondary bg-opacity-30'></div>
            <div className="flex flex-col space-y-3" dir="rtl">
                <p className="text-lg text-center" dir="ltr">Basic ميزات باقة</p>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanArchive} alt="chat" />
                    </div>
                    <p className="text-lg content-center">أرشفة كافة سجلات الحضور.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanNotification} alt="graph" />
                    </div>
                    <p className="text-lg content-center">احصل على إشعارات حول حصصك القادمة.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanLock} alt="save" />
                    </div>
                    <p className="text-lg content-center">قفل التطبيق للاستخدام الشخصي فقط.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanUsersShare} alt="doc search" />
                    </div>
                    <p className="text-lg content-center">إرسال بريد إلكتروني لجميع التلاميذ أو حسب الفوج.</p>
                </div>
            </div>
        </div>
    );
}

export default ComponentPlus;